export class AzureAppRegistrationOption {
    'id';
    'applicationId';
    'servicePrincipalId';
    'applicationType';
    'isAppRegistrationInTenant';
    'createdAt';
    'secretUrl';
    'federatedManagedIdentityResourceId';
    'displayName';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "applicationId",
            "baseName": "applicationId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "servicePrincipalId",
            "baseName": "servicePrincipalId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "applicationType",
            "baseName": "applicationType",
            "type": "AzureAppRegistrationOptionApplicationTypeEnum",
            "format": ""
        },
        {
            "name": "isAppRegistrationInTenant",
            "baseName": "isAppRegistrationInTenant",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "secretUrl",
            "baseName": "secretUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "federatedManagedIdentityResourceId",
            "baseName": "federatedManagedIdentityResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureAppRegistrationOption.attributeTypeMap;
    }
    constructor() {
    }
}
export var AzureAppRegistrationOptionApplicationTypeEnum;
(function (AzureAppRegistrationOptionApplicationTypeEnum) {
    AzureAppRegistrationOptionApplicationTypeEnum["ManagementApp"] = "ManagementApp";
    AzureAppRegistrationOptionApplicationTypeEnum["DataAccessApp"] = "DataAccessApp";
})(AzureAppRegistrationOptionApplicationTypeEnum || (AzureAppRegistrationOptionApplicationTypeEnum = {}));
